import * as React from 'react';
export const IcBatteryWarning = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 9c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1zm-.71 6.29c-.18.19-.29.44-.29.71 0 .13.03.26.08.38s.12.23.21.33c.1.09.21.16.33.21.12.06.25.08.38.08s.26-.02.38-.08c.12-.05.23-.12.33-.21A.99.99 0 0013 16c0-.27-.11-.52-.29-.71-.37-.37-1.05-.37-1.42 0zM16 4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2-1.65 0-3 1.35-3 3v12c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3zm1 15c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h1c.55 0 1-.45 1-1V4h4v1c0 .55.45 1 1 1h1c.55 0 1 .45 1 1v12z'
      fill='currentColor'
    />
  </svg>
);
